import { useTheme } from 'styled-components';

import { SpinningIcon } from '../spinning-icon';

interface IProps {
  children?: string;
}

export const PageLoadingSpinner: React.FC<IProps> = ({ children }) => {
  const theme: any = useTheme();

  const message = children ?? 'One moment please...';

  return (
    <div className="flex items-center justify-center w-full h-96">
      <SpinningIcon color={`fill-${theme.current}-primary`} />
      <span className="text-lg font-normal text-gray-600">{message}</span>
    </div>
  );
};
